import React from "react";
import { Box } from "@mui/material";

const Card4 = () => {
  const layout = [
    { num: 1, col: 2, row: 2 },
    { num: 2, col: 4, row: 2 },
    { num: 3, col: 2, row: 4 },
    { num: 4, col: 4, row: 4 },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 35px)",
        gridTemplateRows: "repeat(5, 30px)",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 2,
      }}
    >
      {layout.map(({ num, col, row }) => (
        <Box
          key={num}
          sx={{
            gridColumn: col,
            gridRow: row,
            width: 43,
            height: 54,
            backgroundColor: "#1976d2",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          {num}
        </Box>
      ))}
    </Box>
  );
};

export default Card4;
